import { Component, Prop, Vue } from "vue-property-decorator";
import ChannelItem from "@/components/ChannelItem.vue"; //
import { AppConfig } from "@/app-config";
import { Channel } from "@/models/channel";
import { Channels } from '@/models/channels';
import { GraphApiResult } from '@/models/graphApiResult';
import { ChannelUtils } from '@/utils/channelUtils';
import { ApiResult } from '@/enums';
import { Consts } from '@/consts';
import { GraphApiUtils } from '@/utils/graphApiUtils';
import { Plans } from '@/models/plans';
import { GroupUtils } from '@/utils/groupUtils';
import { Plan } from '@/models/plan';

@Component({
	components: {
		ChannelItem
	}
})

export default class UserChannels extends Vue {
	@Prop() public groupName!: string;
	private channels: Channels = new Channels();
	private plans: Plans = new Plans();
	private isLoadingChannels: boolean = false;

	public async created(): Promise<void> {
		// アクセストークンが有効でない場合はルートに遷移。
		if (!await GraphApiUtils.isValidAccessToken(Vue.$accessTokenInfo)) {
			this.$router.push(Consts.PATH_USER);
			return;
		}
		const groupId: string | null = localStorage.getItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
		if (groupId === null) {
			return;
		}
		const accessToken: string = Vue.$accessTokenInfo.token;
		try {
			this.isLoadingChannels = true;
			this.channels = new Channels();
			this.plans = new Plans();
			// チャンネルの取得
			const channelsResult: GraphApiResult<Channels> = await ChannelUtils.GetChannels(accessToken, groupId);
			if ((channelsResult.result !== ApiResult.Success) || (channelsResult.value === null)) {
				alert('チャンネル一覧の取得に失敗しました');
				return;
			}
			const channels: Channels | null = channelsResult.value;
			// プランの取得
			const plansResult = await GroupUtils.GetPlans(accessToken, groupId);
			if ((plansResult.result !== ApiResult.Success) || (plansResult.value === null)) {
				alert('プラン一覧の取得に失敗しました');
				return;
			}
			let plans: Plans | null = plansResult.value;
			if (plans === null) {
				return;
			}
			// チャンネル名が違う場合を除く
			plans = plans.isChannel(channels);
			// チャンネルより先にプランが取得されていることを保証してセットする
			this.plans = plans;
			this.channels = channels;
		} finally {
			this.isLoadingChannels = false;
		}
	}

	public clickChannelItem(channelId: string): void {
		const channel: Channel | null = this.channels.get(channelId);
		if (channel === null) {
			return;
		}
		// 選択したチャンネルの画面を表示する
		const path: string = Consts.PATH_USER_CHANNELS + '/' + channelId;
		this.$router.push(path);
	}
}
